import { Sparkles } from 'lucide-react'
import { cn } from '../lib/utils'

interface AiGeneratedTagProps {
  text?: string
  className?: string
}

export const AiGeneratedTag: React.FC<AiGeneratedTagProps> = ({
  text = 'AI 생성 이미지 입니다',
  className,
}) => {
  return (
    <div
      className={cn(
        'inline-flex h-5 items-center gap-1 rounded-md bg-[#EEF1F7] px-2 py-0.5',
        className,
      )}
    >
      <Sparkles className="h-3 w-3 text-[#8F929B]" strokeWidth={1.2} />
      <span className="text-xs text-[#8F929B]">{text}</span>
    </div>
  )
}

export default AiGeneratedTag
